import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import de from './de.json';
import ar from './ar.json';
import ku from './ku.json';

const SUPPORTED = ['en', 'de', 'ar', 'ku'];

function applyDocumentLanguage(lng) {
  const code = (lng || 'en').split('-')[0];
  const resolved = SUPPORTED.includes(code) ? code : 'en';
  document.documentElement.lang = resolved;
  document.documentElement.dir = resolved === 'ar' ? 'rtl' : 'ltr';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      ar: { translation: ar },
      ku: { translation: ku },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED,
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

applyDocumentLanguage(i18n.language);
i18n.on('languageChanged', applyDocumentLanguage);

export default i18n;
